import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "coffee art",
    date: "2 March, 2025",
    admin: "Admin",
    heading: "Design Your Coffee Using Whipped Cream",
    content: 'Whipped cream designs make every coffee cup special.',
    important: {
      content: "Whipped cream isn't just for sweetness — it's a fun and creative way to decorate your coffee. From simple swirls to intricate designs, you can turn any cup into a mini masterpiece.",
      intro: "Coffee Artist"
    },
    paragraph: {
      para1: "Start with freshly brewed coffee and a smooth layer of whipped cream. Ensure the coffee isn't too hot to prevent melting the cream instantly.",
      para2: "Use piping bags or squeeze bottles to create patterns like hearts, spirals, or flowers. Add a touch of chocolate syrup or cinnamon for extra flair.",
      para3: "Practice different nozzle tips to explore textures and effects. You can even stencil shapes on top of the cream using cocoa powder.",
      para4: "Designing your coffee adds a personal touch to your routine and impresses guests. It's a simple way to enjoy your drink with artistic satisfaction."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2,
      images.blog1Gallery3,
      images.blog1Gallery4,
      images.blog1Gallery5,
      images.blog1Gallery6,
    ],
    tags: ["coffee", "whipped", "decorating"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Ava Thompson",
        date: "3 March, 2025",
        content: "I never thought whipped cream could be used so creatively! Can't wait to try these designs.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Noah Kim",
            date: "3 March, 2025",
            content: "Same here! I tried a heart design and it looked amazing."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Emily Zhang",
        date: "3 March, 2025",
        content: "Would love to see a video version of this guide someday!"
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "cupcake pairing",
    date: "21 May, 2025",
    admin: "Admin",
    heading: "Best Cupcakes To Pair With Your Coffee",
    content: 'Cupcakes and coffee together create sweet moments.',
    important: {
      content: "Pairing the right cupcake with your coffee can elevate both the flavor and the experience. Whether you love bold espresso or creamy lattes, there’s a perfect cupcake match for every cup.",
      intro: "Coffee & Dessert Expert"
    },
    paragraph: {
      para1: "Start with classic pairings like chocolate cupcakes with rich dark roast coffee. The bitterness of the coffee balances the sweetness of the dessert.",
      para2: "Vanilla or lemon cupcakes go well with light-bodied coffees or lattes. Their delicate flavors don’t overpower your drink.",
      para3: "Try red velvet cupcakes with caramel or hazelnut lattes for a luxurious treat. Toppings like cream cheese frosting or crushed nuts add more texture.",
      para4: "Experiment to discover your favorite combo. Hosting a coffee and cupcake tasting party can be a fun way to explore different pairings with friends or customers."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2,
      images.blog2Gallery3,
      images.blog2Gallery4,
      images.blog2Gallery5,
      images.blog2Gallery6,
    ],
    tags: ["coffee", "cupcake", "brew"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Sophie Wells",
        date: "22 May, 2025",
        content: "Now I’m craving both coffee and cupcakes! Love these pairing suggestions.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Liam Davis",
            date: "22 May, 2025",
            content: "Red velvet with hazelnut latte is now my new favorite combo!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Nora Bennett",
        date: "22 May, 2025",
        content: "This guide gave me so many new ideas for my café's dessert menu!"
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "morning coffee",
    date: "15 June, 2025",
    admin: "Admin",
    heading: "Reasons Why You Should Drink Coffee In The Morning",
    content: 'Morning coffee brings energy, focus, and comfort.',
    important: {
      content: "Drinking coffee in the morning isn't just a habit — it comes with several benefits. From boosting energy to enhancing focus, your daily cup can set the tone for a productive day.",
      intro: "Morning Routine Coach"
    },
    paragraph: {
      para1: "Caffeine gives you a natural energy boost that helps you wake up and stay alert during the early hours of the day.",
      para2: "Coffee can improve mental focus and concentration, making it easier to start your day with clarity and motivation.",
      para3: "Drinking coffee with a healthy breakfast can improve your metabolism and help regulate appetite throughout the day.",
      para4: "Morning coffee routines also provide a moment of calm, helping reduce stress and giving you a peaceful start before the hustle begins."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2,
      images.blog3Gallery3,
      images.blog3Gallery4,
      images.blog3Gallery5,
      images.blog3Gallery6,
    ],
    tags: ["coffee", "morning", "brew"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Daniel Cooper",
        date: "16 June, 2025",
        content: "Totally agree! My mornings are incomplete without a strong cup of coffee.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Grace Lin",
            date: "16 June, 2025",
            content: "I’ve started drinking coffee with my breakfast and feel more focused at work!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Zara Malik",
        date: "16 June, 2025",
        content: "Loved the point about coffee helping with routine and calm — that’s so true for me."
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "cold brew",
    date: "25 July, 2025",
    admin: "Admin",
    heading: "Top 10 Reasons Why Cold Coffee Is Trending",
    content: 'Cold coffee stays trendy with flavor and style.',
    important: {
      content: "Cold coffee has become a favorite worldwide — and for good reason. From its refreshing taste to its modern appeal, here are 10 reasons it’s more popular than ever.",
      intro: "Coffee Trend Analyst"
    },
    paragraph: {
      para1: "Cold coffee offers a refreshing alternative to hot drinks, especially in warm climates or summer months.",
      para2: "It’s incredibly versatile — you can customize it with syrups, milk alternatives, whipped cream, or even ice cream.",
      para3: "Cold brews and iced lattes are easier on the stomach for some coffee lovers, thanks to their smoother, less acidic profile.",
      para4: "Social media and café culture have made cold coffee visually appealing, with layers, drizzles, and glass aesthetics that are both trendy and Instagram-worthy."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2,
      images.blog4Gallery3,
      images.blog4Gallery4,
      images.blog4Gallery5,
      images.blog4Gallery6,
    ],
    tags: ["coffee", "cold", "brew"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Olivia Reyes",
        date: "26 July, 2025",
        content: "Cold coffee is literally my go-to in summer. I loved how this article summed it up!",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Ethan Brooks",
            date: "26 July, 2025",
            content: "Yes! Iced caramel latte with oat milk is unbeatable right now."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Sana Qureshi",
        date: "26 July, 2025",
        content: "Now I understand why cold brews are everywhere. Great breakdown!"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "latte tips",
    date: "3 October, 2025",
    admin: "Admin",
    heading: "5 Things To Remember When Making a Latte",
    content: 'Latte-making needs care, timing, and smooth milk.',
    important: {
      content: "Crafting the perfect latte takes more than just espresso and milk. These 5 tips will help you create a smooth, balanced, and barista-worthy drink every time.",
      intro: "Home Barista"
    },
    paragraph: {
      para1: "Start with quality espresso — it’s the foundation of any good latte. Use freshly ground beans and the right brew pressure for the best taste.",
      para2: "Milk matters just as much as coffee. Use cold, fresh milk and steam it until it’s smooth and slightly frothy, not bubbly.",
      para3: "Temperature is key: aim for around 150°F (65°C). Overheating the milk can ruin the flavor and texture.",
      para4: "Practice pouring techniques to get beautiful latte art. Even a simple heart or rosette adds a special touch to your cup."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2,
      images.blog5Gallery3,
      images.blog5Gallery4,
      images.blog5Gallery5,
      images.blog5Gallery6,
    ],
    tags: ["coffee", "latte", "morning"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Harper Miles",
        date: "4 October, 2025",
        content: "These tips really helped me fix my latte technique. The milk texture part was a game changer!",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Jonas Ahmed",
            date: "4 October, 2025",
            content: "Same here! I always overheated my milk before — thanks for the clear advice."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Camila Fernandez",
        date: "4 October, 2025",
        content: "Great guide for beginners like me who want to make café-style coffee at home."
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "coffee art",
    date: "10 October, 2025",
    admin: "Admin",
    heading: "How To Brew Coffee The Right Way",
    content: 'Brew your coffee right with heat, time, and love.',
    important: {
      content: "Brewing coffee properly can make all the difference in taste and aroma. Whether you’re using a French press, pour-over, or drip machine, a few key steps will ensure a better cup every time.",
      intro: "Brew Specialist"
    },
    paragraph: {
      para1: "Use freshly ground coffee beans for maximum flavor. Grinding just before brewing helps preserve aroma and depth.",
      para2: "Pay attention to your water-to-coffee ratio. A standard guideline is 1 to 2 tablespoons of coffee per 6 ounces of water, but you can adjust to taste.",
      para3: "Water temperature matters — aim for 195°F to 205°F (90°C to 96°C). Too hot and you’ll burn the grounds; too cool and the flavor won’t fully extract.",
      para4: "Keep your equipment clean and experiment with brew times and techniques until you find your ideal flavor profile. Brewing is both a science and an art!"
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2,
      images.blog6Gallery3,
      images.blog6Gallery4,
      images.blog6Gallery5,
      images.blog6Gallery6,
    ],
    tags: ["coffee", "brew", "latte"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Isla Raymond",
        date: "11 October, 2025",
        content: "I didn’t realize water temperature was so important. This made a huge difference in my morning brew!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Leo Hassan",
            date: "11 October, 2025",
            content: "Same here. Also loved the tip about grind size — I’ve switched to fresh grinding now."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Priya Singh",
        date: "11 October, 2025",
        content: "This article made brewing feel so much more approachable. Thanks for simplifying it!"
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "coffee art",
    date: "12 October, 2025",
    admin: "Admin",
    heading: "Ways to Decorate Coffee with Whipped Cream",
    content: 'Decorate coffee cups using whipped cream ideas.',
    important: {
      content: "Whipped cream is a simple yet stylish way to elevate your coffee presentation. Whether you're entertaining guests or just enjoying your morning cup, decorating with cream adds a personal and artistic touch.",
      intro: "Coffee Presentation Expert"
    },
    paragraph: {
      para1: "Start by preparing a thick, chilled whipped cream that holds its shape well. Add it gently to the top of your coffee using a spoon or piping bag.",
      para2: "Use stencils, cocoa powder, or cinnamon to create patterns over the whipped cream. You can also drizzle chocolate or caramel syrup for extra flair.",
      para3: "Experiment with layering whipped cream and espresso for a dessert-like look. Try adding sprinkles, grated chocolate, or a cherry on top for a fun finish.",
      para4: "Decorating your coffee doesn’t have to be complicated. A little creativity can turn your cup into a café-style treat right at home."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2,
      images.blog7Gallery3,
      images.blog7Gallery4,
      images.blog7Gallery5,
      images.blog7Gallery6,
    ],
    tags: ["coffee", "decorating", "whipped"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Maya Brooks",
        date: "13 October, 2025",
        content: "These ideas are so easy and pretty! I surprised my sister with a heart design today.",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Aiden Clark",
            date: "13 October, 2025",
            content: "Love this! I added cinnamon powder with a stencil and it looked amazing."
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Sara Khanna",
        date: "13 October, 2025",
        content: "Please share more decoration ideas! This was fun and helpful."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "cupcake pairing",
    date: "18 October, 2025",
    admin: "Admin",
    heading: "Cupcake Pairings for Your Coffee Break",
    content: 'Pair cupcakes smartly to match your coffee vibe.',
    important: {
      content: "Coffee and cupcakes are a classic duo. Choosing the right cupcake flavor to match your coffee can enhance both the taste and the overall experience of your break.",
      intro: "Dessert Matchmaker"
    },
    paragraph: {
      para1: "Pair rich, dark roast coffee with decadent chocolate cupcakes. The bold bitterness of the coffee brings out the sweetness in chocolate.",
      para2: "Try vanilla bean or lemon cupcakes with a light latte or cappuccino. Their delicate flavor profiles balance the creamy textures.",
      para3: "For flavored coffee like caramel or hazelnut, red velvet or peanut butter cupcakes offer a perfect sweet and salty combo.",
      para4: "Rotate your pairings based on season — fruit cupcakes with iced coffee in summer, and cinnamon-spiced ones with mochas in winter."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2,
      images.blog8Gallery3,
      images.blog8Gallery4,
      images.blog8Gallery5,
      images.blog8Gallery6,
    ],
    tags: ["coffee", "cupcake", "morning"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Rachel Bloom",
        date: "19 October, 2025",
        content: "Loved the seasonal cupcake idea! I’m doing pumpkin spice cupcakes with cinnamon lattes now.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Tariq Mehta",
            date: "19 October, 2025",
            content: "That sounds so good! I always go for red velvet with my flat white."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Bianca Cruz",
        date: "19 October, 2025",
        content: "This guide gave me inspiration for my café menu. Thank you!"
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "morning coffee",
    date: "22 October, 2025",
    admin: "Admin",
    heading: "Starting Your Day with Coffee Is Great",
    content: 'Coffee mornings offer peace, power, and clarity.',
    important: {
      content: "A morning cup of coffee does more than wake you up — it energizes your body, sharpens your focus, and can even improve your mood. It’s a daily ritual that many find both comforting and essential.",
      intro: "Morning Coffee Enthusiast"
    },
    paragraph: {
      para1: "Coffee stimulates your brain and helps you feel more awake, especially during early hours when your energy levels are low.",
      para2: "Drinking coffee in the morning can boost your metabolism and improve physical performance, making it ideal before work or a workout.",
      para3: "It enhances concentration and memory, making it easier to focus on tasks and stay productive through the first part of your day.",
      para4: "Beyond health benefits, the morning coffee ritual provides a peaceful moment to reflect, plan, or simply enjoy a quiet start."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2,
      images.blog9Gallery3,
      images.blog9Gallery4,
      images.blog9Gallery5,
      images.blog9Gallery6,
    ],
    tags: ["coffee", "morning", "latte"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Omar Siddiqui",
        date: "23 October, 2025",
        content: "My day doesn’t start until I’ve had my coffee. This article totally gets it!",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Layla Winters",
            date: "23 October, 2025",
            content: "I agree! I feel way more focused when I drink coffee before work."
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Hannah Lee",
        date: "23 October, 2025",
        content: "I never thought about the mental clarity part. Great reminder to enjoy it mindfully."
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "cold brew",
    date: "28 October, 2025",
    admin: "Admin",
    heading: "Reasons Cold Coffee Is Taking Over",
    content: 'Cold brews rise fast with taste, ease, and looks.',
    important: {
      content: "Cold coffee has moved from a seasonal treat to a year-round favorite. With its refreshing taste and endless customizations, it's no surprise that it’s becoming the go-to drink for coffee lovers.",
      intro: "Coffee Culture Writer"
    },
    paragraph: {
      para1: "Cold coffee is incredibly versatile. Whether it's iced lattes, cold brews, or frappes, there's a chilled option for every mood and moment.",
      para2: "It’s a more refreshing choice for warm climates and busy lifestyles, perfect for sipping on the go or during afternoon slumps.",
      para3: "Social media has boosted its popularity — cold coffees are often beautifully layered, topped with cream, and made for Instagram.",
      para4: "With the rise of coffee shops offering cold options year-round, it's clear that cold coffee isn't just a trend — it's here to stay."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2,
      images.blog10Gallery3,
      images.blog10Gallery4,
      images.blog10Gallery5,
      images.blog10Gallery6,
    ],
    tags: ["coffee", "cold", "brew"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Jake Thompson",
        date: "29 October, 2025",
        content: "Cold brew is my daily fix now — I don’t even miss hot coffee!",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Mina Patel",
            date: "29 October, 2025",
            content: "Totally! Iced coffee with vanilla is my absolute favorite."
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Oliver Grant",
        date: "29 October, 2025",
        content: "Great breakdown of why it's trending. Now I feel less guilty drinking iced coffee in winter!"
      }
    ]
  }

];

export default blogs;